export default {"src":"https://cdn2.e-farm.com/website-static/_next/static/media/ro.b1ddb833.svg","height":2,"width":3,"blurWidth":0,"blurHeight":0};